// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AlmaLinuxIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 246 241">
    <path
      fill="#86DA2F"
      d="M225.91 135.93c10.45-.8 18.9 6.03 19.7 16.48.8 10.86-6.84 19.7-17.29 20.5a18.4 18.4 0 0 1-19.7-16.88c-.8-10.85 6.44-18.9 17.3-20.1"
    />
    <path
      fill="#24C2FF"
      d="M98.88 221.56c0-10.46 8.04-18.5 17.69-18.5 9.64 0 18.89 8.85 18.89 18.9 0 9.64-8.04 18.09-17.29 18.49-11.65 0-19.3-7.24-19.3-18.9"
    />
    <path
      fill="#FFCB12"
      d="M127.42 104.17c-1.6.8-2.41-.4-2.81-1.6-14.88-27.74-10.46-62.72 15.67-83.62 6.84-5.63 19.7-6.83 25.33-1.2 2.41 2 2.81 4.42 3.22 7.23.8 6.03 2 12.06 6.03 16.88 4.42 5.23 10.05 7.24 16.48 6.84 5.63 0 11.25-.8 14.87 5.63 2.01 3.61 1.2 17.68-2 20.5-1.62 1.2-2.82.4-4.03 0-9.24-3.62-18.9-3.62-28.54-2.01-3.22.4-4.82-.4-4.82-4.02-.4-6.03-1.61-11.66-4.83-16.89-6.03-10.85-17.28-11.25-24.52-1.2-6.03 8.04-7.64 17.69-9.25 27.33-1.6 8.45-1.2 17.29-.8 26.13"
    />
    <path
      fill="#86DA2F"
      d="M137.47 110.2c-.8-1.2-.4-2.41.8-3.21 22.92-20.9 57.09-24.93 83.62-4.43 6.83 5.63 11.25 17.29 7.64 24.12a10 10 0 0 1-6.03 4.83c-5.63 2.41-10.86 4.82-14.48 10.05-3.61 5.22-4.42 11.25-2.81 17.69 1.2 5.22 3.22 10.85-2.01 15.67-2.81 2.82-16.48 5.23-20.1 2.82-1.6-1.2-1.2-2.41-.8-4.02 1.2-10.05-1.2-19.3-4.83-28.14-1.2-3.22-.8-4.83 2.41-5.63 5.63-1.6 10.86-4.42 14.88-8.44 8.84-8.44 6.83-19.3-4.83-24.12-9.24-4.02-18.89-3.22-28.14-2.41-8.84.4-17.28 2.81-25.32 5.22"
    />
    <path
      fill="#24C2FF"
      d="M132.24 120.66c1.2-1.21 2.01-.8 3.22 0 26.53 16.08 40.2 47.83 28.14 78.79-3.22 8.04-13.67 16.08-21.3 14.07-3.22-.8-4.83-2.42-6.44-4.43-3.62-4.82-7.64-9.24-13.67-11.25-6.43-2.01-12.06-.8-17.69 2.41-4.82 2.81-9.64 6.43-15.67 2.81-3.62-2-9.65-14.47-8.44-18.49.8-1.6 2.4-1.6 4.02-1.6 10.05-1.61 18.09-6.44 25.72-12.87 2.42-2.01 4.43-2.01 6.44.8 3.21 4.83 7.23 8.85 12.46 11.66 10.45 6.03 20.5.8 21.7-11.25 1.21-10.05-2.4-18.9-5.62-27.74a160 160 0 0 0-12.87-22.91"
    />
    <path
      fill="#0069DA"
      d="M119.38 123.07c-1.6 8.04-5.23 15.67-10.05 22.5-14.47 21.72-35.38 30.56-61.1 28.15-9.25-.8-16.89-8.44-17.7-16.08-.4-3.22.41-5.63 2.42-8.04 2.81-3.62 5.23-6.84 6.43-11.26 2.41-8.84-.8-16.08-7.23-22.51-8.85-8.84-7.64-16.88 2.81-23.32 1.2-.8 2.81-1.6 4.42-2.4 2.41-1.21 4.42-1.21 5.23 1.6 3.62 9.25 10.85 16.08 18.9 21.7 2.8 2.42 2.8 4.03.4 6.84a30 30 0 0 0-8.05 18.9c-.8 8.84 4.43 14.47 13.27 14.47 5.63 0 10.85-2.01 15.68-4.42 12.46-6.44 22.1-15.68 31.35-25.33 1.2-.4 1.61-1.2 3.22-.8"
    />
    <path
      fill="#FF4649"
      d="M53.45 38.65c.8 0 2.81.4 4.82.8 14.88 2.82 24.12-2.41 28.95-16.48 3.21-9.25 10.05-12.06 18.9-7.24.4 0 .4.4.8.4 9.24 5.23 9.24 6.04 3.61 14.08-4.82 6.43-7.23 13.66-8.44 21.3-.8 4.42-2.41 5.23-6.43 3.62-6.43-2.41-13.27-2.41-20.1 0-7.64 2.41-10.85 9.25-8.44 16.88 3.21 10.05 12.06 14.48 19.7 19.7 7.63 5.23 16.48 8.04 24.92 11.66 1.2.4 3.22.4 2.81 2.41-.4 1.2-2 1.2-3.61 1.2-18.1.81-35.38-2-49.45-14.06C48.22 82.06 38.58 68.8 40.2 50.3c1.2-6.03 5.62-10.46 13.26-11.66"
    />
    <path
      fill="#0069DA"
      d="M20.49 151.6c-9.65 1.21-19.3-6.83-20.1-16.88-.8-9.64 7.24-19.3 16.48-20.1 10.45-1.2 20.1 6.03 20.9 15.68.4 9.25-5.62 20.5-17.28 21.3"
    />
    <path
      fill="#FFCB12"
      d="M189.33 8.5c10.05-.8 19.7 7.23 20.5 17.28.8 9.65-7.24 18.9-16.88 19.7-10.46.8-19.7-6.83-20.5-16.88s6.43-19.3 16.88-20.1"
    />
    <path
      fill="#FF4649"
      d="M84.4 16.14c1.21 10.45-6.02 19.3-16.88 20.9-9.24 1.2-18.9-6.43-20.1-15.28-1.2-11.65 5.23-20.1 16.08-21.3 10.05-1.2 19.7 6.43 20.9 15.68"
    />
  </svg>,
  "AlmaLinux",
);
export default AlmaLinuxIcon;
